import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DriveEtaIcon from '@mui/icons-material/DriveEta'; // Car icon for the list
import InfoIcon from '@mui/icons-material/Info';
import BillGeneration from './BillGeneration/BillGeneration';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Blog from './Blog/Blog';  // Your Blog component
import PackagesPage from './Packages/Package';
import TariffPage from './Teriff/teriff';
import TeriffPageForm from './Teriff/TeriffPageForm';
import ContactPhoneIcon from '@mui/icons-material/SupportAgent';
export const mainListItems =  (onMenuClick) => (
  <React.Fragment>
    <ListItemButton component={Link} to="/dashboard"  onClick={onMenuClick}>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>
    {/* <ListItemButton component={Link} to="/teriff" onClick={onMenuClick}>
      <ListItemIcon>
        <AttachMoneyIcon />
      </ListItemIcon>
      <ListItemText primary="TariffPage" />
    </ListItemButton> */}
    <ListItemButton component={Link} to="/about" onClick={onMenuClick}>
      <ListItemIcon>
        <InfoIcon />
      </ListItemIcon>
      <ListItemText primary="about" />
    </ListItemButton>
    <ListItemButton component={Link} to="/contact" onClick={onMenuClick}>
      <ListItemIcon>
        <ContactPhoneIcon />
      </ListItemIcon>
      <ListItemText primary="Contact Us" />
    </ListItemButton>
    <ListItemButton component={Link} to="/blog" onClick={onMenuClick}>
      <ListItemIcon>
        <LayersIcon />
      </ListItemIcon>
      <ListItemText primary="Blog" />
    </ListItemButton>
    <ListItemButton component={Link} to="/package" onClick={onMenuClick}>
          <ListItemIcon>
            <DriveEtaIcon />
          </ListItemIcon>
          <ListItemText primary="PackagesPage" />
        </ListItemButton>
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Saved reports
    </ListSubheader>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItemButton>
  </React.Fragment>
);


export const adminListItems =  (onMenuClick) => (
  <React.Fragment>
    <ListItemButton component={Link} to="/dashboard"  onClick={onMenuClick}>
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>
    <ListItemButton component={Link} to="/bill-generation" onClick={onMenuClick}>
      <ListItemIcon>
        <BarChartIcon />
      </ListItemIcon>
      <ListItemText primary="BillGeneration" />
    </ListItemButton>
    <ListItemButton component={Link} to="/teriff-page-form" onClick={onMenuClick}>
      <ListItemIcon>
        <AttachMoneyIcon />
      </ListItemIcon>
      <ListItemText primary="TeriffPageForm" />
    </ListItemButton>
  </React.Fragment>
);